import {SchemeLink} from '../../../../applink/SchemeLink';
import {LineBanner as LineBannerOrganism} from '../../../../design-system/organisms/LineBanner/LineBanner';
import {LineBannerItem} from '../../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonItemProps} from '../../type';

export function LineBanner({item}: CommonItemProps) {
  const {title, scheme, subTitle, bgColor, rightImage, eventLog} =
    item as LineBannerItem;
  return (
    <SchemeLink scheme={scheme || undefined}>
      <LineBannerOrganism
        {...putTiaraObjectProps(eventLog)}
        bannerTitle={title}
        subTitle={subTitle}
        bgColor={bgColor}
        rightImage={rightImage}
        onClick={e => LOG_CLICK_EVENT('라인배너_클릭', e)}
      />
    </SchemeLink>
  );
}
